export const ITEM = {
  // AVALIATION: 1,
  DIET: 2,
  MEDICAMENT: 3,
  PROCEDURE: 4
  // PROCEDURE_NANDA: 5,
};
